
export enum PaymentForm
{
    Unset = "Unset",
    Cash = "Cash",
    BankTransfer = "BankTransfer",
    CashAtDelivery = "CashAtDelivery",
    TransferAtDelivery = "TransferAtDelivery", // Przelew wykonany przez kuriera w momencie odbioru paczki
    PostalTransfer = "PostalTransfer", // Kasa nadana na poczcie w formie przelewu
    Crypto = "Crypto",
    Blik = "Blik" 
}


export const PaymentFormNames: Record<PaymentForm, string> = {
    [PaymentForm.Unset]: "Unset",
    [PaymentForm.Cash]: "Gotówka",
    [PaymentForm.BankTransfer]: "Przelew bankowy",
    [PaymentForm.CashAtDelivery]: "Gotówka przy odbiorze",
    [PaymentForm.TransferAtDelivery]: "Przelew przy odbiorze",
    [PaymentForm.PostalTransfer]: "Przelew pocztowy",
    [PaymentForm.Crypto]: "Kryptowaluta",
    [PaymentForm.Blik]: "Blik",
}

export const PaymentFormLabels: Record<string, PaymentForm> = {
    "Unset": PaymentForm.Unset,
    "Gotówka": PaymentForm.Cash,
    "Przelew bankowy": PaymentForm.BankTransfer,
    "Gotówka przy odbiorze": PaymentForm.CashAtDelivery,
    "Przelew przy odbiorze": PaymentForm.TransferAtDelivery,
    "Przelew pocztowy": PaymentForm.PostalTransfer,
    "Kryptowaluta": PaymentForm.Crypto,
    "Blik": PaymentForm.Blik,
}
